import React from "react";
import { Link } from "react-router-dom";
import { useContext } from 'react';
import AuthContext from '../context/auth-context'
import './sidebar.scss';
import * as userpermission from "../utils/PermissionCheck.js"

export default function Sidebar() {

  const authCtx = useContext(AuthContext);

  return (
    <>
      {
        !authCtx.isLogged ? (
          <div></div>
        ) : (
          <div className="d-none d-lg-block" style={{
            backgroundColor: "#white",
            flex: 2,
            border: "1px solid whitesmoke",
            padding: "10px",
            maxWidth: "240px",
            minWidth: "210px",
            overflowY: "auto"
          }}
          >
            <main className="shadow p-3 mb-4 bg-body rounded" style={{ padding: "1rem 0" }}>
              {userpermission.PermissionCheck('can_edit_homes', [...authCtx.permissionList]) &&
                <>
                  <div>
                    <b className="title_menu">Homepages</b>
                    <div style={{ paddingLeft: '0.6rem' }}>
                      <div>
                        <Link to={{ pathname: "/homepages/" }} className="menu_line">
                          All Pages
                        </Link>
                      </div>
                      <div>
                        <Link to={{ pathname: "/maps/" }} className="menu_line">
                          Maps
                        </Link>
                      </div>
                    </div>
                  </div>
                  <hr style={{ margin: '1.5rem 0' }} />
                </>
              }
              {/* <hr style={{ margin: '1.5rem 0' }} />
              <div>
                <b className="title_menu">V Homepages</b>
                <div style={{ paddingLeft: '0.6rem' }}>
                  <div>
                    <Link to={{ pathname: "/homepage/life/" }} className="menu_line">
                      Life
                    </Link>
                  </div>
                  <div>
                    <Link to={{ pathname: "/homepage/smartmoney/" }} className="menu_line">
                      Smart Money
                    </Link>
                  </div>
                  <div>
                    <Link to={{ pathname: "/homepage/thefoodmakers/" }} className="menu_line">
                      The Food Makers
                    </Link>
                  </div>
                  <div>
                    <Link to={{ pathname: "/homepage/valoreresponsabile/" }} className="menu_line">
                      Valore Responsabile
                    </Link>
                  </div>
                </div>
              </div>
              <hr style={{ margin: '1.5rem 0' }} />
              <div>
                <b className="title_menu">Homepages</b>
                <div style={{ paddingLeft: '0.6rem' }}>
                  <div>
                    <Link to={{ pathname: "/homepage/economy/" }} className="menu_line">
                      Economy
                    </Link>
                  </div>
                  <div>
                    <Link to={{ pathname: "/homepage/economy2/" }} className="menu_line">
                      Economy2
                    </Link>
                  </div>
                  <div>
                    <Link to={{ pathname: "/homepage/education/" }} className="menu_line">
                      Education
                    </Link>
                  </div>
                  <div>
                    <Link to={{ pathname: "/homepage/impact/" }} className="menu_line">
                      Impact
                    </Link>
                  </div>
                  <div>
                    <Link to={{ pathname: "/homepage/lifestyle/" }} className="menu_line">
                      Lifestyle
                    </Link>
                  </div>
                  <div>
                    <Link to={{ pathname: "/homepage/startup/" }} className="menu_line">
                      Startup
                    </Link>
                  </div>
                  <div>
                    <Link to={{ pathname: "/homepage/tech/" }} className="menu_line">
                      Tech
                    </Link>
                  </div>
                  <hr style={{ margin: '0.4rem 0', maxWidth: "4rem" }} />
                  <div>
                    <Link to={{ pathname: "/homepage/tv/" }} className="menu_line">
                      Live TV
                    </Link>
                  </div>
                </div>
              </div> */}
              <>
                <div>
                  <b className="title_menu">Articles</b>
                  <div style={{ paddingLeft: '0.6rem' }}>
                    <div>
                      <Link to={{ pathname: "/articles/" }} className="menu_line">
                        All Articles </Link>
                    </div>
                    <div>
                      <Link to={{ pathname: "/articlestags/" }} className="menu_line">
                        Tags </Link>
                    </div>
                  </div>
                </div>
                <hr style={{ margin: '1.5rem 0' }} />
              </>
              <>
                <div>
                  <b className="title_menu">Live</b>
                  <div style={{ paddingLeft: '0.6rem' }}>
                    <div>
                      <Link to={{ pathname: "/liveview/" }} className="menu_line">
                        All Lives/Videos </Link>
                    </div>
                    <div>
                      <Link to={{ pathname: "/livetags/" }} className="menu_line">
                        Tags </Link>
                    </div>
                  </div>
                </div>
                <hr style={{ margin: '1.5rem 0' }} />
              </>
              {userpermission.PermissionCheck('view_user', [...authCtx.permissionList]) &&
                <>
                  <div>
                    <b className="title_menu">Users</b>
                    <div style={{ paddingLeft: '0.6rem' }}>
                      <div>
                        <Link to={{ pathname: "/userpermissions/" }} className="menu_line">
                          All Permissions </Link>
                      </div>
                    </div>
                  </div>
                  <hr style={{ margin: '1.5rem 0' }} />
                </>}
              <div>
                <Link to={{ pathname: "/logout/" }} className="menu_line">
                  Logout
                </Link>
              </div>
            </main>
          </div >
        )
      }
    </>
  );
}

